class ShowMoreProducts extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      item: '.grid__item',
      showMore: '.bottom-btn',
      grid: '.grid',
    };

    const grid = this.querySelector(this.selectors.grid);
    const observer = new MutationObserver((mutationsList, observer) => {
      this.items = this.querySelectorAll(this.selectors.item);
      this.showItems();
    });
    observer.observe(grid, {childList: true});

    this.init();
  }

  init() {
    this.items = this.querySelectorAll(this.selectors.item);
    this.showMore = this.querySelector(this.selectors.showMore);
    this.increment = this.dataset.showItems;

    this.setupEventListeners();
    this.showItems();
  }

  setupEventListeners() {
    this.showMore.addEventListener('click', event => {
      event.preventDefault();
      this.dataset.showItems = +this.dataset.showItems + this.increment;
      this.showItems();
    });
  }

  showItems() {
    const showItems = +this.dataset.showItems;

    if (showItems) {
      this.items.forEach((item, index) => {
        if (index < showItems) {
          item.style.display = 'flex';
        } else {
          item.style.display = 'none';
        }
      });

      if (this.items.length <= showItems) {
        this.showMore.style.display = 'none';
      } else {
        this.showMore.style.display = 'block';
      }
    }
  }
}

customElements.define('show-more-products', ShowMoreProducts);
